/*
 * Dehde · Collection pages (PLP) — Sprint 2
 * Loaded (defer) by sections/collection-products-grid.liquid. Plan: Frontend/collections/BUILD-PLAN.md §6.
 * Delegated listeners only: filters.js re-renders the grid, the facets form and the toolbar parts via innerHTML.
 */
(function () {
  // A2 · mobile "Filtri e ordina" pill opens the same Urban facets dropdown (the toolbar opener is hidden <768px).
  // stopPropagation: the dropdown adds a body click listener on open; letting this click reach body would close it.
  document.addEventListener('click', function (event) {
    var fab = event.target.closest('[data-dehde-open-filters]');
    if (!fab) return;
    event.preventDefault();
    event.stopPropagation();
    var toggler = document.querySelector('.dehde-plp-toolbar .facets_toggler');
    if (toggler) toggler.click();
    // M3 · the drawer's close button is the first thing after it, so Esc works without hunting for focus.
    window.requestAnimationFrame(function () {
      var close = document.querySelector('.dehde-plp-toolbar .facets_toggler--close');
      if (close) close.focus();
    });
  });

  // A2 · tap on the drawer scrim closes the drawer. The scrim is the ::before of the dropdown host
  // (see dehde-plp.css), so the tap target is the host itself, never the panel or anything inside it.
  document.addEventListener('click', function (event) {
    var host = event.target.closest('.dehde-plp-toolbar .dropdown-component--facets');
    if (!host || event.target !== host) return;
    if (event.target.closest('.dropdown-component_wrapper')) return;
    if (!host.querySelector('.dropdown-component_wrapper.dropdown--open')) return;
    var dropdown = host.querySelector('dropdown-component');
    if (dropdown && dropdown.close) dropdown.close();
  });

  // A3 · intro clamp: show "Leggi di più" only when the clamped text actually overflows; toggle open/closed.
  function initIntros(root) {
    (root || document).querySelectorAll('[data-dehde-intro]').forEach(function (intro) {
      var text = intro.querySelector('.dehde-plp-intro_text');
      var toggle = intro.querySelector('[data-dehde-intro-toggle]');
      if (!text || !toggle || intro.hasAttribute('data-open')) return;
      toggle.hidden = !(text.scrollHeight > text.clientHeight + 1);
    });
  }
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-dehde-intro-toggle]');
    if (!toggle) return;
    var intro = toggle.closest('[data-dehde-intro]');
    var open = !intro.hasAttribute('data-open');
    intro.toggleAttribute('data-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.textContent = open ? toggle.dataset.labelLess : toggle.dataset.labelMore;
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initIntros(); });
  } else {
    initIntros();
  }
  window.addEventListener('resize', function () { initIntros(); });

  // A7 · in-grid tiles: Liquid prints each tile after card data-dehde-position (desktop). Below 768px (full-width tile)
  // it moves after card data-dehde-position-mobile, and back above. Re-run after filters.js rewrites the grid.
  var mobileQuery = window.matchMedia('(max-width: 767px)');
  function placeTiles() {
    document.querySelectorAll('[data-dehde-tile]').forEach(function (tile) {
      var position = +(mobileQuery.matches ? tile.dataset.dehdePositionMobile : tile.dataset.dehdePosition);
      var card = tile.parentElement.querySelectorAll(':scope > [data-render-columns]')[position - 1];
      if (card && card.nextElementSibling !== tile) card.after(tile);
    });
  }
  function initTiles() {
    placeTiles();
    document.querySelectorAll('[data-render-grid-products]').forEach(function (grid) {
      new MutationObserver(placeTiles).observe(grid, { childList: true });
    });
  }
  // 10x note 1 · "Ambiente" pills / drawer rows (snippets/dehde-plp-ambiente.liquid). The href always works on its own
  // (server-rendered, crawlable); this only improves it:
  // - S&D mode (data-dehde-facet-for = id of the drawer checkbox): tick that checkbox and let filters.js filter by
  //   AJAX, like a tap in the drawer (multi-select, live count, history).
  // - tag mode: the tag lives in the path, so keep the query string (other filters + sort) across the Ambiente change;
  //   'page' and 'section_id' are dropped (a new Ambiente starts from page 1).
  document.addEventListener('click', function (event) {
    var pill = event.target.closest('[data-dehde-amb]');
    if (!pill || event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
    var input = pill.dataset.dehdeFacetFor ? document.getElementById(pill.dataset.dehdeFacetFor) : null;
    if (input && input.form) {
      event.preventDefault();
      input.checked = !input.checked;
      input.form.dispatchEvent(new Event('input'));
      return;
    }
    // S&D hrefs (url_to_add / url_to_remove) already carry the full query: never merge into them
    if (pill.dataset.dehdeFacetFor || !window.location.search) return;
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    var target = new URL(pill.href, window.location.origin);
    target.search = params.toString(); // tag hrefs carry no query of their own; repeated keys (two brands) survive
    event.preventDefault();
    window.location.href = target.toString();
  });

  // 10x note 3 · Esc closes the filters drawer from anywhere. Urban listens for keyup on the dropdown itself only, so
  // after a tick in the drawer (filters.js re-renders the form, focus falls back to <body>) Esc did nothing.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var host = document.querySelector('.dehde-plp-toolbar .dropdown-component--facets');
    if (!host || !host.querySelector('.dropdown-component_wrapper.dropdown--open')) return;
    var dropdown = host.querySelector('dropdown-component');
    if (dropdown && dropdown.close) {
      dropdown.close();
      var opener = host.querySelector('.facets_toggler');
      // below 768px the opener is hidden: focus goes back to the "Filtri e ordina" pill instead
      var fab = document.querySelector('[data-dehde-open-filters]');
      var back = opener && opener.offsetParent !== null ? opener : fab;
      if (back) back.focus();
    }
  });

  // 10x note 10 · the phone's fixed "Filtri e ordina" pill shows the applied-filter count. filters.js re-renders only
  // the toolbar's [data-filters-count]; copy its number into the pill after every re-render.
  function syncFabCount() {
    var out = document.querySelector('[data-dehde-fab-count]');
    if (!out) return;
    var pan = document.querySelector('.dehde-plp-toolbar [data-filters-count] .facets_count-pan');
    var n = pan ? pan.textContent.trim() : '';
    out.textContent = n;
    out.hidden = !n || n === '0';
  }
  function initFabCount() {
    var source = document.querySelector('.dehde-plp-toolbar [data-filters-count]');
    if (source) new MutationObserver(syncFabCount).observe(source, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFabCount);
  } else {
    initFabCount();
  }

  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', placeTiles);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTiles);
  } else {
    initTiles();
  }

  // UI v2 §3.6 (I17) · chip scroll rows under 768px: dehde-polish.css (part 09) draws a right-edge fade on them.
  // data-end = the row is scrolled to its end or does not overflow at all, and the fade goes. Scroll events do not
  // bubble, hence one capture listener on document. The toolbar row lives inside [data-render-active-facets], which
  // filters.js re-renders via innerHTML on every filter change: re-mark after each swap, and on resize/load.
  var ROW_SELECTOR = '.dehde-plp-chips, .dehde-plp-toolbar .facets-active_wrapper';
  function markRowEnd(row) {
    row.toggleAttribute('data-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 2);
  }
  function markRows() {
    document.querySelectorAll(ROW_SELECTOR).forEach(markRowEnd);
  }
  document.addEventListener('scroll', function (event) {
    var row = event.target;
    if (row && row.nodeType === 1 && row.matches(ROW_SELECTOR)) markRowEnd(row);
  }, { capture: true, passive: true });
  window.addEventListener('resize', markRows);
  window.addEventListener('load', markRows);

  // UI v2 §3.6 (I23) · filtering state: filters.js shows Urban's spinner for the whole fetch
  // (JSOrganizer.togglerLoader(true, '.facets_loader') removes "hidden" from its [data-loader]) and hides it again in
  // finally. Mirror that as aria-busy="true" on the product grid; the CSS dims the grid to .5 meanwhile.
  function initBusy() {
    var holder = document.querySelector('.facets_loader');
    var loader = holder && holder.querySelector('[data-loader]');
    var grid = document.querySelector('[data-render-grid-products]');
    if (!loader || !grid) return;
    new MutationObserver(function () {
      if (loader.classList.contains('hidden')) grid.removeAttribute('aria-busy');
      else grid.setAttribute('aria-busy', 'true');
    }).observe(loader, { attributes: true, attributeFilter: ['class'] });
  }

  function initRowsAndBusy() {
    markRows();
    document.querySelectorAll('[data-render-active-facets]').forEach(function (node) {
      new MutationObserver(markRows).observe(node, { childList: true, subtree: true });
    });
    initBusy();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRowsAndBusy);
  } else {
    initRowsAndBusy();
  }
})();
